import * as v from 'valibot';
import Ajax from '../util/ajax';
import { macroUpdated } from '../features/macros/macrosSlice';
import { hideDialog } from '../reducers/app';
import { macroSchema } from '../types/Macro';
export function saveMacro() {
    return (dispatch, getState) => {
        const { edit_macro_dialog } = getState();
        const ajax = new Ajax(dispatch);
        const url = '/macro/' + edit_macro_dialog.id;
        const obj = {
            id: edit_macro_dialog.id,
            title: edit_macro_dialog.title,
            active: edit_macro_dialog.active,
            // for some reason the macro items are called commands when we post to the backend, we should fix the backend
            commands: JSON.stringify(edit_macro_dialog.items),
        };
        ajax.post(url, obj, data => {
            const res = v.safeParse(macroSchema, data);
            if (res.success) {
                dispatch(macroUpdated(res.output));
            }
            else {
                console.error(v.summarize(res.issues));
            }
            dispatch(hideDialog());
        });
    };
}
